<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

const baseAlertController = useBaseAlertController();
const { isOpen, title, message, buttonLabel, isMessageComponent } =
  storeToRefs(baseAlertController);
</script>

<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger class="hidden">
      <slot name="trigger" />
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>
          <slot name="title">
            {{ title }}
          </slot>
        </DialogTitle>
        <DialogDescription>
          <slot name="description">
            <div>
              <component v-if="isMessageComponent" :is="message" />
              <span v-else class="text-body-1">{{ message }}</span>
            </div>
          </slot>
        </DialogDescription>
      </DialogHeader>
      <slot name="content" />
      <DialogFooter>
        <BaseButton @click="baseAlertController.close">
          {{ buttonLabel }}
        </BaseButton>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<style scoped></style>
